import { isSameDay } from 'date-fns'
import type { GroupedBookingSlots } from '~/@types/graphql-police'
import { PARIS_TIME_ZONE } from '~/helpers/date'
import { tz } from '@date-fns/tz'

export function getCalendarOptions(slots: GroupedBookingSlots[]) {
  const [firstDaySlots, lastDaySlots] = [slots.at(0), slots.at(-1)]

  const minDate = firstDaySlots ? new Date(firstDaySlots.date) : new Date()

  const maxDate = lastDaySlots ? new Date(lastDaySlots.date) : new Date()

  const calendarDaysFromSlots = slots.map((daySlots) => {
    const firstSlot = daySlots.bookingSlots[0]!

    return firstSlot.startDate
  })

  const matchIsDateUnavailable = (calendarDate: Date) => {
    return calendarDaysFromSlots.every((calendarDayFromSlot) => {
      return !isSameDay(calendarDayFromSlot, calendarDate, {
        in: tz(PARIS_TIME_ZONE)
      })
    })
  }

  return {
    minDate,
    maxDate,
    calendarDaysFromSlots,
    matchIsDateUnavailable
  }
}

export const getSlotsFromDay = (slots: GroupedBookingSlots[], day: Date) => {
  const selectedSlotsDay = slots.find((daySlots) => {
    return isSameDay(daySlots.date, day, {
      in: tz(PARIS_TIME_ZONE)
    })
  })

  return selectedSlotsDay?.bookingSlots ?? []
}
